<template lang='pug'>
  v-container(fill-height)
    v-row.full-width
      v-col
        v-row
          v-col(md='6' offset-md='3' sm='8' offset-sm='2')
            v-row(justify='center' align='center').mb-5
              img(src='../assets/bionicmetrics-light.png' width='80%')
            form#signInForm(@submit.prevent='signin').mr-4.ml-4
              v-text-field#email(label='Email' prepend-icon='person' v-model='email' type='email' required autofocus)
              v-text-field#password(prepend-icon='lock'
                label='Password'
                v-model='password'
                min='8'
                :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                @click:append='hidePassword = !hidePassword'
                :type="hidePassword ? 'password' : 'text'"
                required)
              v-row(justify='end')
                v-btn#signInButton(color='primary' :disabled='disableButton' type='submit') Sign In
            v-row.ma-4
              v-col.text-center(col='6')
                v-btn(text color='primary' to='/request')
                  | Forgot Password?
              v-col.text-center(col='6')
                v-btn(text color='primary' href='mailto:sales@bionicmetrics.com') Create Account
</template>


<script>
import _ from 'lodash';
import {mapActions} from 'vuex';
import Notifications from '../services/notification.service';
import External from '../api/external';
import Events from '../services/events.service';

export default {
  name: 'SignIn',
  methods: {
    async signin() {
      this.disableButton = true;
      try {
        const user = (await External.signin(this.email, this.password)).data;
        await this.setUser(user);
        Events.$emit('signin'); // tells App.vue to init services from the root of the Vue App
        this.$router.push(_.get(this.$route, 'query.redirect') || '/');
      } catch (e) {
        this.error(e);
      } finally {
        this.disableButton = false;
      }
    },
    async error(err) {
      if (_.get(err, 'response.data.message') === 'SIGNIN_FAILED') {
        return Notifications.alert('Invalid email or password.');
      }
      if (_.get(err, 'response.data.message') === 'USER_DISABLED') {
        return this.$router.push('confirm');
      }
      if (_.get(err, 'response.data.message') === 'ACCOUNT_DISABLED') {
        await Notifications.alert('This account has been disabled. Please contact support@bionicmetrics.com to re-enable your account.');
      }
      this.disableButton = false;
      console.error('An exception occurred:');
      console.error(err);
      console.error(err.response);
      return err;
    },
    ...mapActions({setUser: 'setUser'})
  },
  data() {
    return {
      disableButton: false,
      hidePassword: true,
      email: null,
      password: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
